import React, { useCallback, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import StoryCross from 'assets/SVG/StoryCross';
import { useDispatch, useSelector } from 'react-redux';
import { likeStoryRequest } from '../../../slice/getStoriesSlice';
import { useNavigate } from 'react-router-dom';

import { sandBuyNowRequest } from '../../../slice/sandBuyNowSlice';
import BuyNow from './components/buyNow/BuyNow';
import ControlsBtn from './components/controlsBtn/ControlsBtn';
import './Reelslider.css';

const ReelsSlider = ({
    stories,
    mutedMap,
    playingMap,
    toggleMute,
    togglePlayPause,
    registerVideoRef,
    setPlayingMap,
    handleCloseSlider,
    initialSlideIndex,
    handleSlideChange,
    swiperRef,
    imagesPath
}) => {
    const [temporaryLiked, setTemporaryLiked] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { currentLanguage } = useSelector(({ main }) => main);

    const handleLike = (storyId) => {
        setTemporaryLiked(true);
        dispatch(likeStoryRequest(storyId));
    };

    const handleBuyNow = useCallback(
        story_id => {
            dispatch(sandBuyNowRequest({ story_id }))
                .unwrap()
                .then(res => {
                    if (res.success) {
                        handleCloseSlider();
                        navigate(
                            `${currentLanguage !== 'hy' ? '/' + currentLanguage : ''}/cart`
                        );
                    }
                });
        },
        [currentLanguage, dispatch, handleCloseSlider, navigate]
    );

    return (
        <div className="reels-swiper-wrapper">
            <Swiper
                direction="vertical"
                pagination={{ clickable: true }}
                spaceBetween={0}
                slidesPerView={1}
                initialSlide={initialSlideIndex}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                onSlideChange={handleSlideChange}
                className="reels-swiper"
            >
                {stories?.map((item, index) => {
                    const nameTrimmed = item?.[`name_${currentLanguage}`]?.trim() || null;
                    const descriptionTrimmed = item?.[`description_${currentLanguage}`]?.trim() || null;
                    return (
                        <SwiperSlide key={item.id} className='reels-slide'>
                            {item.video_path && (
                                <div className="reels-slide-inner">
                                    {/* Close button */}
                                    <div className="reels-close-btn">
                                        <button
                                            className='StoriesControlButtons'
                                            onClick={handleCloseSlider}
                                        >
                                            <StoryCross className={'StoryIcon'} />
                                        </button>
                                    </div>
                                    {item.image === 1 ? (
                                        <img
                                            src={imagesPath + '/' + item.images}
                                            alt='story image_or_video'
                                            className={'StoryVideoImageContent'}
                                        />
                                    ) : (
                                         <video
                                            ref={(el) => registerVideoRef(item.id, el)}
                                            src={`${imagesPath}/${item.video_path}`}
                                           className="reels-video"
                                            muted={mutedMap[item.id] ?? true}
                                            autoPlay
                                            playsInline
                                            preload="auto"
                                            webkit-playsinline="true"
                                            onPlay={() => setPlayingMap((prev) => ({ ...prev, [item.id]: true }))}
                                            onPause={() => setPlayingMap((prev) => ({ ...prev, [item.id]: false }))}
                                            onEnded={() => swiperRef.current?.slideNext()}
                                        />
                                    )}

                                    {!nameTrimmed && !descriptionTrimmed ? (
                                        <div />
                                    ) : (
                                        <BuyNow id={item.id} buy_now={item.buy_now} url={item.url}
                                            nameTrimmed={nameTrimmed} descriptionTrimmed={descriptionTrimmed}
                                            currentLanguage={currentLanguage}
                                            handleBuyNow={handleBuyNow}
                                        />
                                    )}

                                    {
                                        item.image === 0 &&
                                        <ControlsBtn
                                            id={item.id}
                                            liked={item.liked}
                                            likes={item.likes}
                                            togglePlayPause={togglePlayPause}
                                            toggleMute={toggleMute}
                                            playingMap={playingMap}
                                            index={index}
                                            handleLike={handleLike}
                                            mutedMap={mutedMap}
                                            temporaryLiked={temporaryLiked}
                                        />
                                    }
                                </div>
                            )}
                        </SwiperSlide>
                    )
                })}

            </Swiper>
        </div>

    )
}

export default ReelsSlider

